import { connect } from "knockout-store";
import ko from "knockout";
import { pushRoute, r } from "../../utils/routing";

function modalViewModel(params) {
  params.isMobile.subscribe(function (value) {
    vm.isMobile(value);
  });

  const vm = {};
  vm.visible = () => {
    return params.route() !== "/" && params.route() !== r("introduction");
  };

  vm.isOpen = () => params.viewsToggle();

  vm.isMobile = ko.observable(params.isMobile());
  vm.activeView = () => params.route();
  vm.route = (key) => r(key);

  vm.goTo = (url) => {
    pushRoute(url, params.route);
    params.viewsToggle(false);

    // If you switch views via the view toggle, we expect to start from the top of the page. So let's!
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  };

  return vm;
}

function mapStateToParams({ route, viewsToggle, isMobile }) {
  return { route, viewsToggle, isMobile };
}

export default connect(mapStateToParams)(modalViewModel);
